import app from 'flarum/forum/app';
import Component from 'flarum/common/Component';
import Button from 'flarum/common/components/Button';
import extractText from 'flarum/common/utils/extractText';
import editPost from '../utils/editPost';
/**
 * "Modifier" on the pages that show a discussion's text as their own - an
 * article, a rule, a help page (champis-articles), a species description
 * (champis-species), a glossary term, a book, a link (champis-others): the
 * forum's own edit composer for the discussion's first post (editPost), as a post's
 * "Modifier" (showEditNextToReply.tsx), and only for whoever may use it
 * (post.canEdit(): a moderator, its author while the forum allows). The
 * page shows the new text once saved - it reads it from the store.
 *
 * Reached by those extensions through flarum.reg (see index.ts), at render
 * time.
 */
export default class EditPostButton extends Component {
  view() {
    const post = this.attrs.post;
    if (!post || !post.canEdit() || post.isHidden()) return null;
    const label = app.translator.trans('core.forum.post_controls.edit_button');
    return m(Button, {
      className: 'Button Button--link ChampisEditPostButton' + (this.attrs.compact ? ' ChampisEditPostButton--compact' : ''),
      icon: "fas fa-pencil-alt",
      "aria-label": this.attrs.compact ? extractText(label) : undefined,
      title: this.attrs.compact ? extractText(label) : undefined,
      onclick: e => {
        // Not the entry's own click (a book opens its photos).
        e.stopPropagation();
        editPost(post);
      }
    }, this.attrs.compact ? null : label);
  }
}
flarum.reg.add('champis-forum', 'forum/components/EditPostButton', EditPostButton);